import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DatePipe, HashLocationStrategy, LocationStrategy } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AuthHeaderInterceptor } from '@core/interceptors/auth-header.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
// import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { LayoutComponent } from './layout/layout.component';
import { LoadingModule } from '@core/loading/public-api';
import { TicketingComponent } from '@page/ticketing/ticketing/ticketing.component';
import { LogInterceptorService } from '@core/mock-api-setup/log-interceptor.service';
@NgModule({
    declarations: [
        AppComponent,
    ],
    bootstrap: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        SharedModule,
        ToastrModule.forRoot(),
        BsDatepickerModule.forRoot(),
        // MatDialogModule,
        LayoutComponent,
        TicketingComponent,
        LoadingModule
    ],
    providers: [
        DatePipe,
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        // {
        //     provide: HTTP_INTERCEPTORS,
        //     useClass: AuthHeaderInterceptor,
        //     multi: true,
        // },
        // {
        //     provide: HTTP_INTERCEPTORS,
        //     useClass: LogInterceptorService,
        //     multi: true
        // },
        provideHttpClient(withInterceptorsFromDi()),
    ]
})
export class AppModule { }
